<script lang="ts" setup>
const props = defineProps<{
  src: string
  title?: string
  size?: number | string
  width?: number | string
  height?: number | string
  placeImage?: string
  nolazy?: boolean
  fetchpriority?: 'high' | 'low' | 'auto'
  alt?: string
}>()

const imgRef = ref<HTMLImageElement | null>(null)
let url = resizeImgWithConfig(props.src, {
  width: props.width,
  height: props.height
})

const place =
  props.placeImage ?? 'https://resource.mfuns.net/image/placeholder/img-404.png'

if (!props.src) {
  url = place
}

onMounted(() => {
  if (imgRef.value && !props.nolazy) {
    // 如果img标签在.m-image-preview中，直接展示
    if (imgRef.value?.parentElement?.classList.contains('m-image-preview')) {
      imgRef.value.setAttribute('src', url)
      return
    }
    const observer = new IntersectionObserver((entries) => {
      const image = entries[0]
      const dataSrc = imgRef.value?.getAttribute('data-src')
      if (image?.isIntersecting && dataSrc && imgRef.value) {
        imgRef.value.setAttribute('src', dataSrc)
        observer.unobserve(imgRef.value)
      }
    })
    observer.observe(imgRef.value)
  }
})
</script>

<template>
  <img
    ref="imgRef"
    :src="
      nolazy
        ? url
        : 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    "
    :data-src="url"
    :onerror="`this.onerror=null;this.src='${place}'`"
    :style="{
      height: (height ?? isNaN(Number(size))) ? size : `${size}px`,
      width: (width ?? isNaN(Number(size))) ? size : `${size}px`
    }"
    :title="title"
    class="m-img"
    :loading="nolazy ? 'eager' : 'lazy'"
    :fetchpriority="fetchpriority"
    :alt="alt || 'image'"
  />
</template>

<style scoped>
.m-img {
  background-color: var(--color-gray-200);
  object-fit: cover;
  height: inherit;
  width: 100%;
}
</style>
